<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="row">
                    <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
                    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
                        <div class="modal-container" @click.stop>
            
                            <div class="modal-header" style="justify-content: space-between;">
                                <div>
                                    <h4>Scan Location</h4>
                                </div>
                                <div>
                                    <button type="button" class="close" @click="$emit('closeModal')">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                
                            </div>
            
                            <div class="modal-body" v-if="marker">
                                <!-- {{coordinates}} -->
                                <!-- <h4>Total Vehicles : {{marker.length}}</h4> -->
                                <!-- <span style="color:red" v-if="marker.length == 0">No Vehicle Found!</span> -->

                                <GmapMap
                                    :center="{lat:-2.548926, lng:118.0148634}"
                                    :zoom="zoom"
                                    map-type-id="terrain"
                                    style="width: 100%; min-height: 500px"
                                >
                                    <GmapCluster>
                                        <gmap-marker v-for="(m, index) in marker"
                                            :position="m.lat ? m : {lat: 0.00000 , lng: 0.0000}"
                                            :clickable="true" :draggable="true"
                                            :key="index"
                                        ></gmap-marker>
                                    </GmapCluster>
                                </GmapMap>
                                <div style="height:200px;overflow-y:scroll">
                                    <table class="table mt-3">
                                        <thead>
                                            <th>QR Code</th>
                                            <th>Varian</th>
                                            <th>Scan Date</th>
                                            <th>Customer Type</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="data in marker">
                                                <td>{{ data.qrcode }}</td>
                                                <td>{{ data.varian }}</td>
                                                <td>{{ data.scan_date }}</td>
                                                <td>{{ data.customer_type }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="modal-body text-center pt-5 pb-5" v-else>
                                <div class="spinner-border" role="status" style="width:10rem;height:10rem">
                                    <span class="sr-only" >Loading...</span>
                                </div>
                                <h4 class="mt-4">Initialising Map.....</h4>
                            </div>
                                
                        </div>
                    </div>
                    <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
                </div>
            </div>
        </div>
    </transition>
</template>
    
<script>
import moment from 'moment'
import GmapCluster from 'vue2-google-maps/dist/components/cluster' // replace src with dist if you have Babel issues

export default {
    props : ['coordinates' , 'fields' , 'urlAPI' , 'latVar' , 'lngVar'],
    components : {
        GmapCluster,
    },
    data () {
        return {
            moment,
            zoom: 4,
            center: null,
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            marker : null,
            customText : '',
            control : null
        }
    },
    mounted () {
        // setTimeout(this.loadAPI(), 500000);
        let vm = this;
        // vm.loadAPI();

        //The FU(🖕) function for the product team
        setTimeout(function () {
            vm.loadAPI()
        }, this.randomInt(1000,3000));
    },
    watch: {
        customText(newValue) {
            this.updateControl();
        }
    },

    methods : {
        addCustomControl(map) {
            this.control = new CustomControl({text: this.customText}).addTo(map);
        },
        updateControl() {
            if (this.control) {
                this.control.getContainer().innerHTML = this.customText;
            }
        },
        
        
        loadAPI () {
            let latVar = this.latVar ? this.latVar : 'lat'
            let lngVar = this.lngVar ? this.lngVar : 'lng'

            // this.marker = [{
            //         qrcode : 'HTTP://AHM.TO/mQ2xoPEr',
            //         varian : 'Varian A',
            //         scan_date : '2023-10-23 14:00:00',
            //         customer_type : 'Web-Mobile',
            //         lat : -6.14292183,
            //         lng : 106.85673778
            //     },{
            //         qrcode : 'HTTP://AHM.TO/mQ2xoPEr',
            //         varian : 'Varian A',
            //         scan_date : '2023-10-23 14:00:00',
            //         customer_type : 'Web-Mobile',
            //         lat : -6.17292183,
            //         lng : 106.85673778
            //     },{
            //         qrcode : 'HTTP://AHM.TO/mQ2xoPEr',
            //         varian : 'Varian A',
            //         scan_date : '2023-10-23 14:00:00',
            //         customer_type : 'Web-Mobile',
            //         lat : -6.19292183,
            //         lng : 106.85673778
            // }]
            // let coordinates = this.marker

            // this.customText = 'Location Permission Denied Scan : 3'

            // let lat = coordinates[0] && coordinates[0][latVar] ? coordinates[0][latVar] : -6.14292183
            // let lng = coordinates[0] && coordinates[0][lngVar] ? coordinates[0][lngVar] : 106.85673778
            // this.center = [lat , lng]

            this.$http.get(this.urlAPI)
            .then((resp) => {
                let coordinates = resp.data.data
                this.marker = coordinates 
                // console.log(this.marker)
                // let lat = coordinates[0] && coordinates[0][latVar] ? coordinates[0][latVar] : -6.14292183
                // let lng = coordinates[0] && coordinates[0][lngVar] ? coordinates[0][lngVar] : 106.85673778
                // this.center = [lat , lng]

                this.customText = 'Location Permission Denied Scan : ' + coordinates.length
            })
        }
    }
}
</script>

<style scoped>
    .custom-icon {
        background-color: white;
        padding: 7px;
        border: 1px solid #333;
        border-radius: 0 20px 20px 20px;
        box-shadow: 5px 3px 10px rgba(0, 0, 0, 0.2);
        text-align: center;
        width: auto !important;
        height: auto !important;
        margin: 0 !important;
    }

    th {
        border-top: none;
    }

</style>
    

<style>
    .custom-control {
        background-color: #fff;
        border: 1px solid #999;
        padding: 10px;
        box-shadow: 0 1px 5px rgba(0,0,0,0.4);
        border-radius: 5px;
    }
</style>